<template>
  <div class="colorful-background wrapper-grid">
    <div :class="['img', 'animate__fadeIn', { animate__animated: isFirst }]">
      <image-box img-u-r-l="/pic/11.png"></image-box>
    </div>

    <div :class="['title', { animate__animated: isFirst }, 'animate__flipInX']">
      <span class="big-font">
        {{ stuInfo.timeBefore }}<span class="middle-font">天前</span>
      </span>
      <span class="middle-font">
        我们在杭电相遇
      </span>
    </div>

    <div
      :class="[
        'text',
        'animate__fadeIn',
        'middle-margin-top',
        { animate__animated: isFirst },
      ]"
      style="align-items: flex-end;"
    >
      <span class="small-font">在{{ stuInfo.timePoint }}</span>
      <span class="small-font"></span>
      <span class="small-font">您借阅了《{{stuInfo.first}}》</span>
      <span class="small-font too-long-text">
        这是您在此借阅的第一本书
      </span>
<!--      <span class="small-font">是一名大{{ grade }}的学生</span>-->
    </div>

    <div
      :class="[
        'slogan',
        'animate__fadeIn',
        'big-margin-top',
        { animate__animated: isFirst },
      ]"
    >
      <span class="small-font">与杭电图书馆邂逅</span>
      <span class="small-font">一起翻开人生之书的全新章节</span>
    </div>

    <div class="footer middle-margin-bottom">
      <span class="very-small-font"
        >数据由杭电图书馆提供,分析数据均在理想情况下计算</span
      >
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'studentInfoPage',
  components: { ImageBox },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  watch: {},
  computed: {
    stuInfo: function () {
      console.log(store.state.$data.data.lead)
      return store.state.$data.data.lead
    },
    grade: function () {
      let tempGrade = this.stuInfo.Grade
      switch (tempGrade) {
        case 1:
          return '一'
        case 2:
          return '二'
        case 3:
          return '三'
        case 4:
          return '四'
        case 5:
          return '五'
        case 6:
          return '六'
        case 7:
          return '七'
      }
      return '???'
    },
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--second-delay);
  /*animation-duration: var(--defalut-continue);*/
}

.text.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--fourth-delay);
  animation-duration: var(--defalut-continue);
}
</style>
